<template>
  <div
    class="templateThree"
    v-lazy:background-image="{
      src: data.bg,
    }"
    :style="{ backgroundColor: data.bgColor }"
  >
    <title-widge
      :title="data.title"
      :subTitle="data.subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
      :fontBg="fontBg"
      :fontBgColor="fontBgColor"
    ></title-widge>
    <div class="divImg">
      <img class="img1" :src="data.url1" />
      <img class="img2" :src="data.url2" />
    </div>
  </div>
</template>

<script>
import titleWidge from "./../../ai/components/titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(8,228,242,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    fontBg: {
      type: String,
      default: "02",
    },
    fontBgColor: {
      type: String,
      default: "rgba(10,226,242,1)",
    },
    bgColor: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.templateThree {
  height: 831px;
  position: relative;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  .divImg {
    width: 1201px;
    height: 545px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 2px 15px 43px 0px rgba(42, 81, 154, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    position: relative;
    bottom: -16px;
    .img1 {
      width: 367px;
      margin-right: 13px;
    }
    .img2 {
      width: 753px;
    }
  }
}
</style>
